<template>
	<i class="el-icon-success" />
</template>

<style lang="scss" scoped>
i {
	color: var(--color--success);
}
</style>
